import { render, staticRenderFns } from "./MaterialDashboardSearch.vue?vue&type=template&id=500f40b8&scoped=true&"
import script from "./MaterialDashboardSearch.vue?vue&type=script&lang=js&"
export * from "./MaterialDashboardSearch.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDashboardSearch.vue?vue&type=style&index=0&id=500f40b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f40b8",
  null
  
)

export default component.exports